import * as ProfileActionTypes from 'actiontypes/profile';

import deleteEntrySuccess from './deleteEntrySuccess';
import fetchProfileSuccess from './fetchProfileSuccess';
import fetchSharedContentSuccess from './fetchSharedContentSuccess';

/**
 * Initial state
 * @type {Object}
 */
const initialState = {
  isFetching: false,
  lookingAtOwnProfile: false,
  description: null,
  currentArea: null,
  profileCharacter: null,
  standardEquipped: null,
  expandedEquipped: null,
  mantelpiece: null,
  scrapbook: null,
  sharedContent: [],
  isSharing: false,
  shareMessageResponse: null,
  next: null,
  prev: null,
};

/**
 * Character Reducer
 * @param {Object} state
 * @param {[Object]} action
 */
export default function reducer(state = initialState, action) {
  const { payload = {} } = action;

  switch (action.type) {
    case ProfileActionTypes.FETCH_PROFILE_REQUESTED:
      return { ...state, isFetching: true };

    case ProfileActionTypes.FETCH_PROFILE_FAILURE:
      return { ...state, isFetching: false };

    case ProfileActionTypes.FETCH_PROFILE_SUCCESS:
      return fetchProfileSuccess(state, payload);

    case ProfileActionTypes.FETCH_SHARED_CONTENT_SUCCESS:
      return fetchSharedContentSuccess(state, payload);

    case ProfileActionTypes.UPDATE_DESCRIPTION_SUCCESS:
      return {
        ...state,
        profileCharacter: {
          ...state.profileCharacter,
          description: action.newDescription,
        },
      };

    case ProfileActionTypes.SHARE_CONTENT_REQUESTED:
      return { ...state, isSharing: true };

    case ProfileActionTypes.SHARE_CONTENT_FAILURE:
      return { ...state, isSharing: false };

    case ProfileActionTypes.SHARE_CONTENT_SUCCESS:
      return {
        ...state,
        isSharing: false,
        shareMessageResponse: action.shareMessageResponse,
      };

    case ProfileActionTypes.SHARE_CONTENT_COMPLETE:
      return {
        ...state,
        shareMessageResponse: null,
      };

    case ProfileActionTypes.DELETE_ENTRY_SUCCESS:
      return deleteEntrySuccess(state, payload);

    case ProfileActionTypes.DELETE_ENTRY_FAILURE:
      return { ...state, isFetching: false };

    case ProfileActionTypes.DELETE_ENTRY_REQUESTED:
      return { ...state, isFetching: true };

    case ProfileActionTypes.UPDATE_DESCRIPTION_FAILURE:
    case ProfileActionTypes.UPDATE_DESCRIPTION_REQUESTED:
      return state;

    default:
      return state;
  }
}